import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Icon } from "@mui/material";
import "./MatchViewPT.css"
import colors from "../../../assets/theme/base/colors"

function MatchViewPT({ tableData }) {
    const { t } = useTranslation();
    const dataTableData = {
        columns: [
            { Header: t(""), accessor: "lineNo" },
            { Header: t("PORONDAMA"), accessor: "pv" },
            { Header: t("Female"), accessor: "fv" },
            { Header: t("Male"), accessor: "mv" },
            {
                Header: t("Shuba") + '/'+ t("Ashuba"),accessor: "S", Cell: ({ cell, row }) => <div style={{textAlign : "center", backgroundColor : 
                    cell.row.original.s ? colors.badgeColors.success.background : cell.row.original.a ? colors.badgeColors.error.background : colors.badgeColors.info.background }}>
                    {cell.row.original.s && t("Shuba")}
                    {cell.row.original.m && t("Madyama")}
                    {cell.row.original.a && t("Ashuba")}
                </div>,
            },
            { Header: t("AshtaKutayaShort"), accessor: "ak" },
        ],
        rows: tableData
    }
    return (
        <MDBox pt={0} pb={1}>
            
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData}                        
                    />
               
        </MDBox>
    );
};

MatchViewPT.propTypes = {
    tableData: PropTypes.array,
    cell: PropTypes.shape({
        row: PropTypes.shape({
          original: PropTypes.shape({
            a: PropTypes.string.isRequired,
            s: PropTypes.string.isRequired,
            m: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    row : PropTypes.shape({
        
        values: PropTypes.shape({
            s: PropTypes.string.isRequired,
            m: PropTypes.string.isRequired,
            a: PropTypes.string.isRequired,
          }).isRequired,
    }),
};

export default MatchViewPT;